<template>
    <app-sercheable-data-table :headers="headers" :search="search" :refresh="refresh" :pagination="pagination">
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn :to="{ name: 'contractCreate' }" color="primary">{{ $t('label.createContract') }}</v-btn>
        </template>
        <template slot="items" slot-scope="{item}">
            <router-link :to="{ name: 'contractEdit', params: { id: item.id }}" tag="tr">
                <td class="contract-office">{{ item.office.officeNameDisplay }}</td>
                <td class="contract-number">{{ item.number }}</td>
                <td class="validity">{{ item.validityTerm.validityDisplay }}</td>
                <td class="is-active">{{ item.status }}</td>
                <td>{{ item.description }}</td>
                <td class="contract-estimatedTime">{{ item.estimatedTime }}</td>
                <td class="contract-executedTime">{{ item.executedTime }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
// import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../shared/SercheableDataTable';

export default {
    data() {
        return {
            pagination: {
                descending: true,
                sortBy: 'number',
            },
            headers: [
                {
                    text: this.$t('label.office'),
                    value: 'office.officeNameDisplay',
                    align: 'left'
                },
                {
                    text: this.$t('label.number'),
                    value: 'number',
                    align: 'left',
                },
                {
                    text: this.$t('label.validity'),
                    value: 'validityTerm.validityDisplay',
                    align: 'left',
                },
                {
                    text: `${this.$t('label.active')}?`,
                    value: 'status',
                    align: 'left',
                },
                {
                    text: this.$t('label.description'),
                    value: 'description',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Quantidade Orçada',
                    value: 'number',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Quantidade Executada',
                    value: 'number',
                    align: 'left',
                    sortable: false,
                },
            ],
        };
    },

    computed: {
        contracts() {
            const contracts = this.$store.getters.contracts;
            contracts.forEach((contract) => { contract.status = contract.isActive ? this.$t('label.yes') : this.$t('label.no'); });
            return contracts;
        },
        readonly() {
            return !this.$store.getters.isAdmin;
        },
    },

    components: {
        appSercheableDataTable: SercheableDataTable,
    },

    methods: {
        search(filters) {
            return utilities.filterMultiple(this.contracts, filters, (contract, regex) => (
                regex.test(contract.office.officeNameDisplay) ||
                regex.test(contract.number) ||
                regex.test(contract.description) ||
                regex.test(contract.validityTerm.validityDisplay) ||
                regex.test(contract.status)
            ));
        },
        async refresh() {
            await this.$store.dispatch('loadContracts');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/contracts/Index.vue